import React from "react"
import PropTypes from "prop-types"
import "./index.less"
import { validate } from "../../../../../../utils/functions"

export function CustomTooltip(props) {
  let payload = {}
  if (validate.exist(props.element) && props.element.active) {
    if (
      validate.exist(props.element.payload) &&
      props.element.payload.length > 0
    ) {
      payload = props.element.payload[0].payload
    }
  }

  return (
    <div className="tooltipBarContainer">
      <div className="tooltipTitle">
        <span>{payload.name}</span>
      </div>
      <div className="tooltipData">
        <span className="tooltipPercent">{payload.value_text}</span>{" "}
        <span className="tooltipDetail">{`(${payload.value} respuestas)`}</span>
      </div>
    </div>
  )
}

CustomTooltip.propTypes = {
  element: PropTypes.object,
  measureGeneral: PropTypes.object,
}

export default CustomTooltip
